import logGAEvent from '../helpers/logGAEvent';
import EVENT_ACTIONS from '../constants/EVENT_ACTIONS';
import CONFIG from '../constants/CONFIG';

/**
 * Used for dispatching a GA Event before navigating
 * to the consent page. This function should be used as an
 * event listener on the manage button in the cookie banner.
 *
 * @param event
 */
const navigateToConsentPage = (event) => {
  event.stopPropagation();
  event.preventDefault();

  logGAEvent(EVENT_ACTIONS.NAVIGATED_TO_CONSENT_PAGE);

  window.location.href = CONFIG.CONSENT_PAGE_URL;
};

export default navigateToConsentPage;
